const SYSTEM_SECTION_PATHS = [
  '/Portal/Instructor/setting',
  '/Portal/Instructor/packages',
  '/Portal/Instructor/ImportCourse',
  '/Portal/Instructor/TrainingSection',
];

function isSystemSectionPath(pathname) {
  if (!pathname) {
    return false;
  }
  if (SYSTEM_SECTION_PATHS.includes(pathname)) {
    return true;
  }
  return pathname.startsWith('/Portal/Instructor/system/');
}

/**
 * Determines whether a sidebar link should appear active for the current route.
 * Uses path-segment boundaries so `/settings` does not match `/setting`.
 */
export function isSidebarLinkActive(location, link) {
  if (!link || !location) {
    return false;
  }

  const pathname = location.pathname || '';
  const search = location.search || '';
  const [linkPath, linkQuery = ''] = link.split('?');
  const linkSearch = linkQuery ? `?${linkQuery}` : '';

  if (linkPath === '/Portal/Instructor') {
    return pathname === linkPath;
  }

  if (linkPath.startsWith('/Portal/Instructor/admin')) {
    if (pathname.startsWith('/Portal/Instructor/admin')) {
      return true;
    }
    if (pathname === '/Portal/Instructor/settings' && search === '?tab=org') {
      return true;
    }
    return false;
  }

  if (linkPath.startsWith('/Portal/Instructor/billing')) {
    return pathname === linkPath || pathname.startsWith(`${linkPath}/`);
  }

  if (
    linkSearch === '?tab=plan'
    && linkPath === '/Portal/Instructor/settings'
  ) {
    return (
      pathname === linkPath && search === linkSearch
    ) || pathname.startsWith('/Portal/Instructor/billing');
  }

  if (
    linkSearch === '?tab=profile'
    && linkPath === '/Portal/Instructor/settings'
  ) {
    if (pathname === '/Portal/Instructor/profile' || pathname === '/Portal/Instructor/account') {
      return true;
    }
    // The Settings item owns every Settings tab (profile, account, register, …)
    // except ?tab=org, which highlights the Admin item instead.
    return pathname === linkPath && search !== '?tab=org';
  }

  if (linkPath === '/Portal/Instructor/setting') {
    return isSystemSectionPath(pathname);
  }

  if (linkQuery) {
    return pathname === linkPath && search === linkSearch;
  }

  if (pathname === linkPath) {
    return true;
  }

  return pathname.startsWith(`${linkPath}/`);
}
